<template>
<div class="col-md-12">
    <h2>
        Sign Up
    </h2>
    <div class="form">
        <div class="form-group">
            <label>
                Email
            </label>
            <input
                type="text"
                placeholder="email"
                class="form-control"
                v-model="email"
            >
        </div>
        <div class="form-group">
            <label>
                Password
            </label>
            <input
                type="password"
                placeholder="password"
                class="form-control"
                v-model="password"
            >
        </div>
        <button class="btn btn-primary" @click="signUp">
            Sign Up
        </button>
        <p>
            {{ error.message }}
        </p>
        <router-link to="/signin">
            Already a user? Sign In
        </router-link>
    </div>
</div>
</template>

<script>
import { firebaseApp } from '../firebaseApp'

export default {
    data() {
        return {
            email: '',
            password: '',
            error: {
                message: ''
            }
        }
    },
    methods: {
        signUp() {
            firebaseApp.auth().createUserWithEmailAndPassword(this.email, this.password)
                .catch(error => {
                    this.error = error
                })
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/Signup.vue